import { convertToEnglishNumber } from "./convertToEnglishNumber";

// Invisible characters inserted by Persian/Arabic keyboards and copy-paste
// (ZWNJ, ZWSP, NBSP, RTL/LTR marks, Arabic letter mark, BOM, etc.)
const INVISIBLE_CHARS = /[\u200B-\u200F\u202A-\u202E\u2066-\u2069\u061C\u00A0\u2000-\u200A\uFEFF]/g;

export const normalizeIranianPhone = (input: string): string => {
  let value = convertToEnglishNumber(String(input ?? ""))
    .replace(INVISIBLE_CHARS, "")
    .replace(/[\s\-().]/g, "")
    .trim();

  if (/^(\+98|0098|98)9\d{9}$/.test(value)) {
    value = `0${value.slice(value.length - 10)}`;
  } else if (/^9\d{9}$/.test(value)) {
    value = `0${value}`;
  }

  return value;
};
